import script from "./PortfolioComponent.vue?vue&type=script&lang=ts&setup=true"
export * from "./PortfolioComponent.vue?vue&type=script&lang=ts&setup=true"

import "./PortfolioComponent.vue?vue&type=style&index=0&id=fa59def8&scoped=true&lang=css"

import exportComponent from "/opt/builds/JFRxnycJ/0/firma/firmenwebseite/website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fa59def8"]])

export default __exports__